var MDB = window.MDB || {};
MDB.Calls = MDB.Calls || {};

MDB.Calls.boot = function (config) {

    MDB.Calls.getReportStatuses = function() {
        var id = $('#DivisionId')[0].value;

        var url = config.getStatusesUrl + '/' + encodeURIComponent(id);
        window.location.href = url;
    };

    MDB.Calls.inheritFromParent = function() {
        MDB.prompt(
            MDB.loadResourceString('Mangl_Calls_ReportStatus_Inherit_Title'),
            sprintf(MDB.loadResourceString('Mangl_Calls_ReportStatus_Inherit_Body'), name),
            function (ok) {
                if (ok) {
                    var id = $('#DivisionId')[0].value;

                    $.ajax({
                        url: "/Mangl/Calls/InheritStatuses",
                        type: "GET",
                        data: {
                            Id: id
                        },
                        cache: false,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function (data) {
                            if (data.success === true) {
                                MDB.Calls.getReportStatuses();
                            }
                        }
                    });
                }
            }
        );
    }

};